<app-breadcrumb *ngIf="!(ofwca || dialogRef)" xmlns="http://www.w3.org/1999/html" master="Struktura sieci"
                parentName="OFWCA" name="Dodaj"></app-breadcrumb>
<div class="ofwca-add-container" [formGroup]="ofwcaForm" fxLayout="column" fxLayoutGap="15px">
  <div class="status-info" *ngIf="ofwcaObject">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + ofwcaObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="ofwcaObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    <a href="/rest/crm/static/doc/Klauzula_informacyjna_GRUPA_ASF.pdf" target="_blank" mat-stroked-button color="primary">
      Klauzula informacyjna
    </a>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane osobowe</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Imię</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Imię" formControlName="firstName" [required]="true">
                  <mat-error *ngIf="ofwcaForm.get('firstName').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Drugie imię</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Drugie imię" formControlName="secondName" [required]="false">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Nazwisko</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Nazwisko" formControlName="lastName" [required]="true">
                  <mat-error *ngIf="ofwcaForm.get('lastName').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>PESEL</mat-label>
                  <input matInput placeholder="PESEL" formControlName="pesel" [required]="true">
                  <mat-error *ngIf="ofwcaForm.get('pesel').hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="ofwcaForm.get('pesel').hasError('invalidPesel')">Podaj prawidłowy numer PESEL</mat-error>
                  <mat-error *ngIf="ofwcaForm.get('pesel').hasError('backendError')">{{formErrors.pesel}}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
                <span fxFlex="50"></span>
                <mat-slide-toggle fxFlex="50" color="accent" formControlName="withoutPesel">Brak PESEL</mat-slide-toggle>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Nazwisko rodowe</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Nazwisko rodowe" formControlName="familyName" [required]="requireFullDataFields">
                  <mat-error *ngIf="ofwcaForm.get('familyName').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Nazwisko panieńskie matki</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Nazwisko panieńskie matki" formControlName="mothersMaidenName" [required]="requireFullDataFields">
                  <mat-error *ngIf="ofwcaForm.get('mothersMaidenName').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Imię matki</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Imię matki" formControlName="mothersName" [required]="requireFullDataFields">
                  <mat-error *ngIf="ofwcaForm.get('mothersName').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Imię ojca</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Imię ojca" formControlName="fathersName" [required]="requireFullDataFields">
                  <mat-error *ngIf="ofwcaForm.get('fathersName').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Miejsce urodzenia</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="birthPlace" [required]="requireFullDataFields">
                  <mat-error *ngIf="ofwcaForm.get('birthPlace').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <app-datepicker
                  label="Data urodzenia"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="getControl('birthDate')"
                ></app-datepicker>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-dict fxFlex="100" [label]="'Płeć'" [dictType]="'gender'"
                          [control]="getControl('sex')" [required]="true"></app-dict>
              </div>

              <div fxFlex="50">
                <app-dict fxFlex="100" [label]="'Wykształcenie'" [dictType]="'education'"
                          [control]="getControl('education')" [required]="true"></app-dict>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Obywatelstwo</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Obywatelstwo" formControlName="citizenship" [required]="true">
                  <mat-error *ngIf="ofwcaForm.get('citizenship').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <app-datepicker
                  label="Data uzyskania pierwszego wpisu w KNF"
                  placeholder="2000-01-01"
                  [required]="false"
                  [control]="getControl('firstKnfEntry')"
                ></app-datepicker>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-chips-input-control fxFlex="100" label="Numer RAU" [arrayControl]="getControl('rauNumbers')"></app-chips-input-control>


            </div>

            <div  fxLayout="row"  fxLayoutGap="15px">
              <mat-form-field class="partners-add-input" fxFlex="100" >
                <mat-label>Numer rachunku bankowego</mat-label>
                <input
                  prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                  matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387" formControlName="accountNumber"
                >
                <mat-error *ngIf="ofwcaForm.get('accountNumber').hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
              </mat-form-field>
            </div>

<!--            <div fxLayout="row" *ngIf="ofwcaObject">-->
<!--              <div fxFlex="100">-->
<!--                <mat-slide-toggle class="slide-padding" color="accent" formControlName="verified">Rekord zweryfikowany</mat-slide-toggle>-->
<!--              </div>-->
<!--            </div>-->

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf='(userPermissions | async).settlement.delete'>
        <div fxFlex="100" >
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Blokady rozliczeń ASF</h3>
            </div>

            <div  fxLayout="row"  fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle formControlName="settlementSendBlockAsf" color="accent">Blokada wysyłki rozliczenia ASF</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle formControlName="settlementSendBlockPremium" color="accent">Blokada wysyłki rozliczenia ASF Premium</mat-slide-toggle>
              </div>
            </div>
            <div  fxLayout="row"  fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle formControlName="billAddBlockAsf" color="accent">Blokada dodawania rachunku ASF</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle formControlName="billAddBlockPremium" color="accent">Blokada dodawania rachunku ASF Premium</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <app-slide-form-field formControlName="krkRequestedByOfwca" label="KRK wyrabiane przez OFWCA"></app-slide-form-field>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dokument tożsamości</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-dict fxFlex="100" [label]="'Typ'" [dictType]="'document_type'"
                          [control]="getControl('documentType')" [required]="false"></app-dict>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Organ wydający</mat-label>
                  <input matInput placeholder="Organ wydający" formControlName="documentIssuer" [required]="false">
                </mat-form-field>
              </div>

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Numer</mat-label>
                  <input matInput placeholder="XYZ001122" formControlName="documentNumber" [required]="false">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-datepicker-id-format
                  label="Data wydania"
                  [required]="false"
                  [control]="getControl('documentIssueDate')"
                ></app-datepicker-id-format>
              </div>

              <div fxFlex="50">
                <app-datepicker-id-format
                  label="Data ważności"
                  [required]="false"
                  [control]="getControl('documentExpirationDate')"
                ></app-datepicker-id-format>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card fxLayout="column">
            <div fxLayout="row">
              <h3>Kontakt email </h3>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Adres email główny</h5>
<!--              <div class="list-add-button">-->
<!--                <button (click)="addEmail('mainEmails')" mat-icon-button color="primary">-->
<!--                  <mat-icon>add_box</mat-icon>-->
<!--                </button>-->
<!--              </div>-->
            </div>

            <div fxLayout="row" *ngIf="mainEmails.length === 0">
              <mat-error>Musisz podać przynajmniej jeden adres główny</mat-error>
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of mainEmails; index as i">
                <div fxLayout="column" class="separator" [formGroup]="formGroup" >

                  <!-- EMAIL + NAZWA -->
                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Adres</mat-label>
                          <input matInput placeholder="adres@asf.com.pl" formControlName="email" [required]="true">
                          <mat-error *ngIf="formGroup.get('email').hasError('required')">To pole jest wymagane</mat-error>
                          <mat-error *ngIf="formGroup.get('email').hasError('email')">Podaj poprawny adres email</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removeEmail(i, 'mainEmails')" mat-icon-button color="warn"
                                *ngIf="mainEmails.length > 1">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten adres email?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</div>-->
<!--                    -->
<!--                  </div>-->
                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten adres email?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</p>
                  </div>

                  <!-- ZGODY -->
                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing" fxFlex="50" >
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="50">
                      Produktowe
                    </mat-slide-toggle>

                  </div>

                </div>

              </ng-container>
            </div>

            <div class="add-button">
              <button  class="small-button" (click)="addEmail('mainEmails')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Adresy email dodatkowe</h5>
<!--              <div class="list-add-button">-->
<!--                <button (click)="addEmail('additionalEmails')" mat-icon-button color="primary">-->
<!--                  <mat-icon>add_box</mat-icon>-->
<!--                </button>-->
<!--              </div>-->
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of additionalEmails; index as i">
                <div fxLayout="column" class="separator" [formGroup]="formGroup" >

                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Adres</mat-label>
                          <input matInput placeholder="adres@asf.com.pl" formControlName="email" [required]="true">
                          <mat-error *ngIf="formGroup.get('email').hasError('email')">Podaj poprawny adres email</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removeEmail(i, 'additionalEmails')" mat-icon-button color="warn">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten adres email?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</div>-->
<!--                  </div>-->
                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten adres email?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</p>
                  </div>


                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing"  fxFlex="50">
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="50">
                      Produktowe
                    </mat-slide-toggle>

                  </div>

                </div>
              </ng-container>
            </div>

            <div class="add-button">
              <button  class="small-button" (click)="addEmail('additionalEmails')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>



          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card" fxLayout="column">

            <div fxLayout="row">
              <h3>Kontakt telefoniczny</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Numer telefonu główny</h5>
<!--              <div class="list-add-button">-->
<!--                <button (click)="addPhone('mainPhones')" mat-icon-button color="primary">-->
<!--                  <mat-icon>add_box</mat-icon>-->
<!--                </button>-->
<!--              </div>-->
            </div>

            <div fxLayout="row" *ngIf="mainPhones.length === 0">
              <mat-error>Musisz podać przynajmniej jeden numer główny</mat-error>
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of mainPhones; index as i">
                <div fxLayout="column" [formGroup]="formGroup" class="separator">

                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Numer</mat-label>
                          <input matInput placeholder="+48 500 200 300" formControlName="phone" [required]="true" prefix="+48" mask=" 000 000 000">
                          <mat-error *ngIf="formGroup.get('phone').hasError('required')">To pole jest wymagane</mat-error>
                          <mat-error *ngIf="formGroup.get('phone').hasError('invalidPhoneNumber')">Podaj poprawny numer telefonu</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removePhone(i, 'mainPhones')" mat-icon-button color="warn"
                                *ngIf="mainPhones.length > 1">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten numer telefonu?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</div>-->
<!--                  </div>-->

                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten numer telefonu?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</p>
                  </div>

                  <!-- ZGODY -->
                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing" fxFlex="50" >
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="50">
                      Produktowe
                    </mat-slide-toggle>

                  </div>

                </div>
              </ng-container>
            </div>

            <div class="add-button">
              <button   class="small-button" (click)="addPhone('mainPhones')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Numer telefonu dodatkowe</h5>
<!--              <div class="list-add-button">-->
<!--                <button (click)="addPhone('additionalPhones')" mat-icon-button color="primary">-->
<!--                  <mat-icon>add_box</mat-icon>-->
<!--                </button>-->
<!--              </div>-->
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of additionalPhones; index as i">
                <div fxLayout="column" [formGroup]="formGroup" class="separator">

                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Numer</mat-label>
                          <input matInput placeholder="+48 500 200 300" formControlName="phone" [required]="true" prefix="+48" mask=" 000 000 000">
                          <mat-error *ngIf="formGroup.get('phone').hasError('required')">To pole jest wymagane</mat-error>
                          <mat-error *ngIf="formGroup.get('phone').hasError('invalidPhoneNumber')">Podaj poprawny numer telefonu</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="ofwca-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removePhone(i, 'additionalPhones')" mat-icon-button color="warn">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten numer telefonu?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</div>-->
<!--                  </div>-->

                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten numer telefonu?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</p>
                  </div>

                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing"  fxFlex="50">
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="50">
                      Produktowe
                    </mat-slide-toggle>

                  </div>

                </div>
              </ng-container>
            </div>


            <div class="add-button">
              <button   class="small-button"  (click)="addPhone('additionalPhones')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>


          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3> Konto ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaObject?.user360?.length > 0">
              <div fxFlex="100">
                <ng-container *ngFor="let user of ofwcaObject?.user360; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">


                    <button
                      fxFlex="35"
                      mat-raised-button
                      [ngClass]="user.active ? 'positive-button' : 'negative-button'"
                    >
                      {{ user.active ? 'Konto aktywne' : 'Konto nieaktywne' }}
                    </button>


                    <app-detail fxFlex="65" header="Login">{{ user.username }}</app-detail>

                  </div>
                </ng-container>
              </div>
            </div>

<!--            <div fxLayout="column">-->
<!--              <h3 style="margin-bottom: 0;">Treści na tablicy OFWCA</h3>-->
<!--              <span style="font-size: 14px; font-style: italic;">-->
<!--              Wybierz rodzaje treści, które będą wyświetlane na tablicy ofwca po zalogowaniu do ASF360-->
<!--            </span>-->
<!--            </div>-->

            <div fxLayout="row">
              <h4 class="structure-title">Treści na tablicy OFWCA</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Wybierz rodzaje treści, które będą wyświetlane na tablicy ofwca po zalogowaniu do ASF360</p>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle color="accent" formControlName="productMessageConsent">
                  Aktualności produktowe
                </mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle color="accent" formControlName="contestMessageConsent">
                  Aktualności marketingowe
                </mat-slide-toggle>
              </div>
            </div>

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <app-detail-bool header="Aktualności produktowe " [value]="ofwcaObject.productMessageConsent"></app-detail-bool>-->
<!--              </div>-->

<!--              <div fxFlex="50">-->
<!--                <app-detail-bool header="Aktualności marketingowe" [value]="ofwcaObject.contestMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="!requireFullDataFields">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="withoutAddress">Brak adresu</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="ofwcaForm.get('withoutRegisteredAddress').enabled">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="withoutRegisteredAddress">Brak adresu zameldowania</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <app-address-form *ngIf="this.getGroup('registeredAddress').enabled" title="Adres zameldowania" [addressForm]="getGroup('registeredAddress')"></app-address-form>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="this.getGroup('registeredAddress').enabled">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="livingAddressSameAsRegistered">Adres zamieszkania taki sam jak zameldowania</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <app-address-form *ngIf="this.getGroup('livingAddress').enabled" title="Adres zamieszkania" [addressForm]="getGroup('livingAddress')"></app-address-form>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="this.getGroup('registeredAddress').enabled || this.getGroup('livingAddress').enabled">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="this.getGroup('registeredAddress').enabled">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="communicationAddressSameAsRegistered">Adres korespondencyjny taki sam jak zameldowania</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="communicationAddressSameAsLiving">Adres korespondencyjny taki sam jak zamieszkania</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <app-address-form *ngIf="this.getGroup('communicationAddress').enabled" title="Adres korespondencyjny" [addressForm]="getGroup('communicationAddress')"></app-address-form>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <ng-container *ngIf="facilityObject">
                <mat-form-field fxFlex="100">
                  <mat-select [formControl]="getControl('partner')" [required]="true"
                              [multiple]="false" placeholder="Partner">
                    <mat-option *ngFor="let option of partners" [value]="option.uuid">
                      {{option.shortName}} (NIP: {{option.nip}})
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="getControl('partner').hasError('required')">To pole jest wymagane</mat-error>
                </mat-form-field>
              </ng-container>
              <app-detail *ngIf="partnerObject" fxFlex="100" label="Partner" [value]="partnerObject.shortName"></app-detail>
              <app-dict-partners *ngIf="
                                      !partnerObject &&
                                      !facilityObject &&
                                       (
                                         !ofwcaObject ||
                                         (userPermissions | async)?.ofwca?.admin_root ||
                                         (!ofwcaObject.partner && (userPermissions | async)?.ofwca?.write)
                                       )"
                                 fxFlex="100" label="Partner" [control]="getControl('partner')" [required]="false"></app-dict-partners>
            </div>

<!--            <div fxLayout="row">-->
<!--              <app-dict-partners  fxFlex="100" label="Właściciel" [control]="getControl('companyOwner')" [required]="false"></app-dict-partners>-->
<!--            </div>-->

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100" *ngIf="facilityObject">
                <app-detail label="Placówka" [value]="facilityObject.address.searchString"></app-detail>
              </div>

              <ng-container *ngIf="!facilityObject">
                <div fxFlex>
                  <app-partner-facility-select label="Placówka" [control]="getControl('facility')" [multiple]="false" [required]="true"
                                               [partnerId]="partnerId"></app-partner-facility-select>
                </div>
                <div *ngIf="partnerId | async">
                  <button mat-raised-button color="accent"
                    style="position: relative; top: 10px" (click)="addFacility()"
                  ><mat-icon>add</mat-icon><span> Dodaj</span></button>
                </div>
              </ng-container>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Numer Profitowi</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Numer Profitowi" formControlName="profitNumber" [required]="false">
                </mat-form-field>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row" >
              <h3>Umowa z pracownikiem</h3>
            </div>

            <div fxLayout="row" style="margin-top: -29px">
              <h4>  Pole uzupełniamy tylko w przypadku, gdy OFWCA w strukturze występuje również jako Partner lub jest właścicielem spółki. Gdy pole jest uzupełnione system nie wymaga od OFWCA umowy z pracownikiem. </h4>
            </div>

            <div fxLayout="row">
              <app-dict-partners  fxFlex="100" label="Właściciel" [control]="getControl('companyOwner')" [required]="false"></app-dict-partners>
            </div>


          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" >-->
<!--        <div fxFlex="100">-->
<!--          <mat-card>-->
<!--            <div fxLayout="row">-->
<!--              <h3>Zgody</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <mat-slide-toggle color="accent" formControlName="productMessageConsent">-->
<!--                  Aktualności produktowe-->
<!--                </mat-slide-toggle>-->
<!--              </div>-->
<!--              <div fxFlex="50">-->
<!--                <mat-slide-toggle color="accent" formControlName="contestMessageConsent">-->
<!--                  Aktualności marketingowe-->
<!--                </mat-slide-toggle>-->
<!--              </div>-->
<!--            </div>-->
<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%"  *ngIf="!ofwcaObject?.hiperioAgencyUnitsUuid">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Hiperio</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaObject?.assetsRegional?.uuid!='d095058c-cf4e-4928-be5a-ae55af272d4b'">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="hiperioGrantingAccess">
                  Nadanie dostępu
                </mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" *ngIf="!ofwcaObject?.hiperioAgencyUnitsUuid" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Email hiperio</mat-label>
                  <input  matInput placeholder="Email hiperio" formControlName="hiperioEmail" [required]="ofwcaForm.get('hiperioGrantingAccess').value">
                  <mat-error *ngIf="ofwcaForm.get('hiperioEmail').hasError('backendError')">{{formErrors.hiperioEmail}}</mat-error>
                </mat-form-field>
              </div>
            </div>

<!--            <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaObject?.assetsRegional?.uuid!='d095058c-cf4e-4928-be5a-ae55af272d4b'">-->
<!--              <div fxFlex="100">-->
<!--                <mat-slide-toggle color="accent" formControlName="hiperioAutomaticAccessUpdate">-->
<!--                  Automatyczna aktualizacja dostępów-->
<!--                </mat-slide-toggle>-->
<!--              </div>-->
<!--            </div>-->

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"  *ngIf="ofwcaObject && ofwcaObject.sex.key === SEX_FEMALE">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Urlop Macierzyński</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-datepicker-id-format
                  label="Data od"
                  [required]="maternityLeave"
                  [control]="getControl('maternityLeaveFrom')"
                ></app-datepicker-id-format>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="100">
                <app-datepicker-id-format
                  label="Data do"
                  [required]="maternityLeave"
                  [control]="getControl('maternityLeaveTo')"
                ></app-datepicker-id-format>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <textarea formControlName="note" matInput placeholder="Uwagi"></textarea>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    <a href="/rest/crm/static/doc/Klauzula_informacyjna_GRUPA_ASF.pdf" target="_blank" mat-stroked-button color="primary">
      Klauzula informacyjna
    </a>
  </div>
</div>
